import { useState } from 'react';
import second from '../../../Images/img2.png';
import { variableName } from '../../../variableName';
// import { Carousel, Image } from 'react-bootstrap';

function Slider() {


    // useEffect(() => {
    //     setInterval(() => {
    //         setSelectedImage(selectedImage => selectedImage > 1 ? 0 : selectedImage + 1)
    //     }, 2500);
    // }, [])

    return (
        <>
            <div className="center-wrapper" style={{ height: window.innerHeight / 1.2 }}>

                <div className="image-card">

                    <img src={second} className="card-image"
                        alt={"ImagePlaceholder"}
                    />

                    <h3 className="card-header">{variableName.outerHeaderName}</h3>

                </div>

            </div>

        </>
    )
}
export default Slider;